module.exports = __webpack_public_path__ + "img/6_142.64c63163.png";